module.exports = __webpack_public_path__ + "img/401.336a32a9.png";